import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavBar, Button, Form, Input, Card, Toast } from 'antd-mobile';
import { LeftOutline } from 'antd-mobile-icons';
import { passwordChange } from '../../api/auth';

export default function SettingsPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleReset = () => {
    form.resetFields();
  };

  const handleSubmit = async (values: {
    current_password: string;
    new_password: string;
    confirm_password: string;
  }) => {
    setLoading(true);
    try {
      const res = (await passwordChange(values)).data;
      if (res.success) {
        Toast.show({ icon: 'success', content: '密码修改成功' });
        setTimeout(() => navigate(-1), 1200);
      } else {
        Toast.show({ icon: 'fail', content: res.message || '修改失败' });
      }
    } catch (_e) {
      Toast.show({ icon: 'fail', content: '网络异常' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-page">
      <NavBar
        onBack={() => navigate(-1)}
        backArrow={<LeftOutline fontSize={20} />}
        className="settings-nav"
      >
        修改密码
      </NavBar>

      <div className="settings-content">
        <Card title="修改密码" className="settings-card">
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            footer={
              <div className="settings-footer">
                <Button
                  type="submit"
                  color="primary"
                  block
                  size="large"
                  loading={loading}
                  disabled={loading}
                  className="settings-submit-btn"
                >
                  <span style={{ color: '#fff' }}>提交</span>
                </Button>
                <Button
                  block
                  fill="outline"
                  size="large"
                  onClick={handleReset}
                  disabled={loading}
                  className="settings-clear-btn"
                >
                  清空
                </Button>
              </div>
            }
          >
            <Form.Item
              name="current_password"
              label="原密码"
              rules={[{ required: true, message: '请输入原密码' }]}
            >
              <Input
                type="password"
                placeholder="请输入原密码"
                className="password-input"
              />
            </Form.Item>

            <Form.Item
              name="new_password"
              label="新密码"
              rules={[{ required: true, message: '请输入新密码', min: 6 }]}
            >
              <Input
                type="password"
                placeholder="请输入新密码（至少6位）"
                className="password-input"
              />
            </Form.Item>

            <Form.Item
              name="confirm_password"
              label="确认密码"
              rules={[{ required: true, message: '请再次输入新密码' }]}
            >
              <Input
                type="password"
                placeholder="请再次输入新密码"
                className="password-input"
              />
            </Form.Item>
          </Form>
        </Card>
      </div>

      <style>
{`
        .settings-page {
          min-height: 100vh;
          background: #F5F7FA;
        }
        .settings-nav .adm-nav-bar {
          background: #fff;
          color: #1F2433;
          font-size: 17px;
          font-weight: 600;
          border-bottom: 1px solid #E8ECF3;
        }
        .settings-content {
          padding: 16px;
        }
        .settings-card {
          margin-bottom: 12px;
        }
        .settings-footer {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-top: 16px;
        }
        .settings-submit-btn {
          border-radius: 10px;
          font-size: 16px;
          font-weight: 600;
          height: 44px;
        }
        .settings-clear-btn {
          border-radius: 10px;
          font-size: 16px;
          font-weight: 500;
          height: 44px;
          color: #6B7280;
          border-color: #E5E7EB !important;
        }
        .password-input .adm-input {
          border-radius: 8px;
          height: 44px;
        }
        .adm-form-item-label {
          font-size: 14px;
          font-weight: 500;
          color: #1F2433;
        }
`}
</style>
    </div>
  );
}
